export default __webpack_public_path__ + "static/media/info_icon.05995221.svg";